import { render } from "./NavbarButton.vue?vue&type=template&id=dc41e6b2&scoped=true"
import script from "./NavbarButton.vue?vue&type=script&lang=js"
export * from "./NavbarButton.vue?vue&type=script&lang=js"

import "./NavbarButton.vue?vue&type=style&index=0&id=dc41e6b2&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc41e6b2"]])

export default __exports__